var map = {
	"./00-intro/00-intro.pug": 130,
	"./01-serverless/01-serverless.pug": 131,
	"./02-project/02-project.pug": 132,
	"./03-lambda/03-lambda.pug": 133,
	"./04-vue/04-vue.pug": 134,
	"./05-other/05-other.pug": 135,
	"./06-thanks/06-thanks.pug": 136
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 282;


//////////////////
// WEBPACK FOOTER
// ./src/slides \.md|markdown|\.pug$
// module id = 282
// module chunks = 1